module.exports = __webpack_public_path__ + "static/media/WhipAround_android_3.b222117f.jpg";